<template>
 <v-card  v-if="$vuetify.breakpoint.smAndDown"
    height="100vh"
    flat
    color="transparent"
    class="d-flex justify-center align-center"
  >
    <v-card
      color="transparent"
      height="50%"
      class="d-flex flex-column align-center mt-n12"
      flat
    >
      <v-row class="align-center">
          <h1>Kontaktformular</h1>
      </v-row>
    <v-row>
    </v-row>
      <v-row class="d-flex align-center">
        <v-card contain class="d-flex flex-row" flat
                style="height: 62px; border: 3px solid #333333; border-radius: 5px;">
          <v-text-field
            style="width: 300px !important; font-size:22px;"
            solo
            flat
            v-model="email"
            placeholder="Emailadresse"
            :rules="[rules.required, rules.email]"
            class="ma-1"
          ></v-text-field>
<!--
          <img style="cursor:pointer !important;" height="60px" :src="registerImage"
               @mouseover="registerImage=registerRed"
               @mouseleave="registerImage=registerBlack" @click="subscribeClick()" class="mt-3"/>
-->
        </v-card>
          </v-row>  
        <v-row>
        <v-card contain class="d-flex flex-row mt-1" flat
                style="height: 272px; border: 3px solid #333333; border-radius: 5px;">
          <v-text-field
            style="width: 300px !important; font-size:22px;"
            solo
            flat
            v-model="message"
            placeholder="Nachricht"
            class="ma-1"
          ></v-text-field>
<!--
          <img style="cursor:pointer !important;" height="60px" :src="registerImage"
               @mouseover="registerImage=registerRed"
               @mouseleave="registerImage=registerBlack" @click="subscribeClick()" class="mt-3"/>
-->
        </v-card>
          
      </v-row>
        
      <v-row>
            <v-btn x-large color="#3D3D3D" class="mt-4" dark @click="messageClick()" >Senden</v-btn>
      </v-row>    
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
<!--
          <v-card-title class="headline">Thank you for your message! We will process and reply as soon as possible.</v-card-title>
  
-->
          
              <h2 class="wrappingThankyou">
                  Thank you for your message! We will process and reply as soon as possible.
    </h2>
              
            </v-card>
    </v-dialog>
        
<!--
      <v-dialog
        v-model="dialog"
        max-width="560"
      >
          <v-card height="250" class="pt-3 pb-3">
    Thanks for sending us the message!      
              </v-card>
      </v-dialog>
-->
    </v-card>
  </v-card>


  <!---########################DESKTOP VIEW############################-->

  <v-card v-else
    height="100vh"
    flat
    color="transparent"
    class="d-flex justify-center align-center"
  >
    <v-card
      color="transparent"
      height="50%"
      class="d-flex flex-column align-center mt-n12"
      flat
    >
      <v-row class="align-center">
          <h1>Kontaktformular</h1>
<!--
        <div class="display-2 font-weight-light" v-html="$t('page5.text1')">
        </div>
-->
      </v-row>
    <v-row>
    </v-row>
      <v-row class="d-flex align-center">
        <v-card contain class="d-flex flex-row" flat
                style="height: 62px; border: 3px solid #333333; border-radius: 5px;">
          <v-text-field
            style="width: 450px !important; font-size:22px;"
            solo
            flat
            v-model="email"
            placeholder="Emailadresse"
            :rules="[rules.required, rules.email]"
            class="ma-1"
          ></v-text-field>
<!--
          <img style="cursor:pointer !important;" height="60px" :src="registerImage"
               @mouseover="registerImage=registerRed"
               @mouseleave="registerImage=registerBlack" @click="subscribeClick()" class="mt-3"/>
-->
        </v-card>
          </v-row>  
        <v-row>
        <v-card contain class="d-flex flex-row mt-2" flat
                style="height: 272px; border: 3px solid #333333; border-radius: 5px;">
          <v-text-field
            style="width: 450px !important; font-size:22px;"
            solo
            flat
            v-model="message"
            placeholder="Nachricht"
            class="ma-1"
          ></v-text-field>
<!--
          <img style="cursor:pointer !important;" height="60px" :src="registerImage"
               @mouseover="registerImage=registerRed"
               @mouseleave="registerImage=registerBlack" @click="subscribeClick()" class="mt-3"/>
-->
        </v-card>
          
      </v-row>
        
      <v-row>
            <v-btn x-large color="#3D3D3D" class="mt-4" dark @click="messageClick()" >Senden</v-btn>
      </v-row>    
      <v-dialog
        v-model="dialog"
        max-width="290"
      >
        <v-card>
<!--
          <v-card-title class="headline">Thank you for your message! We will process and reply as soon as possible.</v-card-title>
  
-->
          
              <h2 class="wrappingThankyou">
                  Thank you for your message! We will process and reply as soon as possible.
    </h2>
              
            </v-card>
    </v-dialog>
        
<!--
      <v-dialog
        v-model="dialog"
        max-width="560"
      >
          <v-card height="250" class="pt-3 pb-3">
    Thanks for sending us the message!      
              </v-card>
      </v-dialog>
-->
    </v-card>
  </v-card>
</template>

<script>
  import { subscribe } from '../services'

  export default {
    data: () => ({
      email: '',
      rules: {
        required: value => !!value || 'Required.',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        },
      },
      dialog: false,
      registerBlack: require('../assets/register_black.png'),
      registerRed: require('../assets/register_red.png'),
      registerImage: null
    }),
    methods: {
      messageClick() {
        subscribe(this.email).then(res => {
            console.log(res)
            this.dialog = true
          })
          .catch(err => {
            console.log(err)
            this.dialog = true
          })
      }
    },
    created() {
      this.registerImage = this.registerBlack
    }
  }
  ;
</script>
